import { render, staticRenderFns } from "./base-carousel.vue?vue&type=template&id=392a9c26"
import script from "./base-carousel.vue?vue&type=script&lang=js"
export * from "./base-carousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports